import type { VehicleModelOption } from "../../types/reference-list.types";
import type { VehicleModelDto } from "@/lib/api";

/** Undefined without an id: nothing can reference such a model. */
export function toVehicleModelOption(
	model: VehicleModelDto | undefined
): VehicleModelOption | undefined {
	if (!model?.id) return undefined;

	return {
		id: model.id,
		brand: model.brand ?? "",
		fullName:
			model.fullName || [model.brand, model.name].filter(Boolean).join(" "),
	};
}

/**
 * The model catalogue as picker options, sorted by brand then name: an
 * Autocomplete grouped by brand repeats a group header whenever the brand
 * changes, so each brand's models have to be adjacent.
 */
export function toVehicleModelOptions(
	items: Array<VehicleModelDto>
): Array<VehicleModelOption> {
	return items
		.flatMap((item) => toVehicleModelOption(item) ?? [])
		.sort(
			(a, b) =>
				a.brand.localeCompare(b.brand) || a.fullName.localeCompare(b.fullName)
		);
}
